export type ForecastMode = "Actual" | "Forecast" | "Mixed";

export interface ForecastReportYear {
	Year: number;
}

export interface ForecastReportMonth {
	Month: string;
	ForecastedProduction: number | null;
	ActualProduction: number | null;
	Number: number;
	Name: string;
	Year: number;
}

export interface ForecastReportAnalytics {
	ProductionYear: number;
	Mean: number | null;
	LastYearActualProduction: number | null;
	Increase: number | null;
	StandardDeviation: number | null;
	CoefficientOfVariation: number | null;
	Range: number | null;
	PRR: number | null;
}

export interface ForecastReportData {
	years: ForecastReportYear[];
	monthly: ForecastReportMonth[];
	analytics: ForecastReportAnalytics[];
}

export const YEAR_COLOR_PALETTE = [
	"#4bb730",
	"#f89406",
	"#e04e22",
	"#44aa84",
	"#3688dc",
	"#d46bd0",
	"#33f61c",
	"#1cbaf6",
	"#d4d16b",
	"#1255f1",
	"#787a7d",
] as const;
